import { render } from "./DataPegawai.vue?vue&type=template&id=739586d4"
import script from "./DataPegawai.vue?vue&type=script&lang=js"
export * from "./DataPegawai.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__